window.backToTop = function() {
    if (window.scrollY > 100) {
        $('.back-to-top').addClass('active')
    } else {
        $('.back-to-top').removeClass('active')
    }
};
